import React, { useEffect, useState } from "react";
import "./ProfilePage.css";
import "bootstrap/dist/css/bootstrap.min.css";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {

  const [profile, setProfile] = useState({});
  const [editingField, setEditingField] = useState(null);
  const [formData, setFormData] = useState({});
  const [address, setAddress] = useState("")

  const navigate = useNavigate();

  const [passwordData, setPasswordData] = useState({
    oldPassword: "",
    newPassword: ""
  });

  useEffect(() => {
    fetchProfile();
    fetchAddress();
  }, []);

  const fetchProfile = async () => {
    try {
      const res = await API.get("/api/user/profile");
      console.log(res.data)
      setProfile(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAddress = async () => {
    try {
      const res = await API.get("/api/address/selected")
      setAddress(res.data)
    } catch (error) {
      console.log(error)
    }
  }

  const handleSave = async () => {
    try {
      let updatedData = { ...profile, ...formData };

      if (editingField === "gender") {
        updatedData.gender = formData.gender;
      }

      if (editingField === "name") {
        updatedData.name = `${formData.firstName} ${formData.lastName}`;
        delete updatedData.firstName;
        delete updatedData.lastName;
      }

      if (editingField === "mobile") {
        updatedData.phone = formData.phone;
        delete updatedData.mobile;
      }

      await API.put("/api/user/updateProfile", updatedData);

      setProfile({ ...profile, ...updatedData });
      setEditingField(null);

    } catch (err) {
      console.log(err);
    }
  };

  const handlePasswordChange = async () => {
    try {
      await API.put("/api/user/change-password", passwordData);
      setEditingField(null);
      setPasswordData({ oldPassword: "", newPassword: "" });
    } catch (err) {
      console.log(err);
    }
  };

  const splitName = (name) => {
    const parts = (name || "").split(" ");
    return {
      firstName: parts[0] || "",
      lastName: parts.slice(1).join(" ") || ""
    };
  };

  return (
    <div className="container-fluid profile-container">
      <div className="row">

        {/* SIDEBAR */}
        <div className="col-md-3 sidebar">
          <div className="user-box">
            <div className="avatar">
              {profile.name?.charAt(0)}
            </div>
            <div>
              <p className="hello-text">Hello,</p>
              <h6 className="username">{profile.name}</h6>
            </div>
          </div>

          <div className="menu">
            <p className="menu-title">ACCOUNT SETTINGS</p>
            <div className="menu-item active">Profile Information</div>
          </div>
        </div>

        {/* CONTENT */}
        <div className="col-md-9 content">

          {/* PERSONAL INFO */}
          <div className="card-box">
            <h5>Personal Information</h5>

            {/* NAME */}
            <div className="info-row">
              <span>Full Name</span>

              {editingField === "name" ? (
                <>
                  <input
                    className="form-control me-2"
                    value={formData.firstName}
                    onChange={(e) =>
                      setFormData({ ...formData, firstName: e.target.value })
                    }
                  />
                  <input
                    className="form-control me-2"
                    value={formData.lastName}
                    onChange={(e) =>
                      setFormData({ ...formData, lastName: e.target.value })
                    }
                  />

                  <button className="save-btn" onClick={handleSave}>Save</button>
                  <button className="cancel-btn" onClick={() => setEditingField(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <span>{profile.name}</span>
                  <button
                    className="edit-btn"
                    onClick={() => {
                      setEditingField("name");
                      const { firstName, lastName } = splitName(profile.name || "");
                      setFormData({ firstName, lastName });
                    }}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>

            {/* GENDER */}
            <div className="info-row">
              <span>Gender</span>

              {editingField === "gender" ? (
                <>
                  <select
                    className="form-control"
                    value={formData.gender || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, gender: e.target.value })
                    }
                  >
                    <option>Male</option>
                    <option>Female</option>
                  </select>

                  <button className="save-btn" onClick={handleSave}>Save</button>
                  <button className="cancel-btn" onClick={() => setEditingField(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <span>{profile.gender}</span>
                  <button
                    className="edit-btn"
                    onClick={() => {
                      setEditingField("gender");
                      setFormData({ gender: profile.gender || ""});
                    }}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
            <div className="info-row">
              <span>Your Address</span>
              <span>{address
                ? `${address.city}, ${address.state}`
                : "Select Location"}</span>

              <button
                className="edit-btn"
                onClick={() => navigate("/choose-location", { state: { from: "profile" } })}
              >
                Edit
              </button>
            </div>
          </div>

          {/* CONTACT */}
          <div className="card-box mt-3">
            <h5>Contact Details</h5>

            <div className="info-row">
              <span>Email</span>
              <span>{profile.email}</span>
            </div>

            {/* MOBILE */}
            <div className="info-row">
              <span>Mobile</span>

              {editingField === "mobile" ? (
                <>
                  <input
                    className="form-control"
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                  />
                  <button className="save-btn" onClick={handleSave}>Save</button>
                  <button className="cancel-btn" onClick={() => setEditingField(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <span>{profile.phone}</span>
                  <button
                    className="edit-btn"
                    onClick={() => {
                      setEditingField("mobile");
                      setFormData({ phone: profile.phone });
                    }}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
          </div>

          {/* CHANGE PASSWORD */}
          <div className="card-box mt-3">
            <h5>Change Password</h5>

            {editingField === "password" ? (
              <>
                <input
                  type="password"
                  placeholder="Old Password"
                  className="form-control mb-2"
                  value={passwordData.oldPassword}
                  onChange={(e) =>
                    setPasswordData({ ...passwordData, oldPassword: e.target.value })
                  }
                />

                <input
                  type="password"
                  placeholder="New Password"
                  className="form-control mb-2"
                  value={passwordData.newPassword}
                  onChange={(e) =>
                    setPasswordData({ ...passwordData, newPassword: e.target.value })
                  }
                />

                <button className="save-btn" onClick={handlePasswordChange}>Save</button>
                <button className="cancel-btn" onClick={() => setEditingField(null)}>Cancel</button>
              </>
            ) : (
              <button
                className="edit-btn"
                onClick={() => setEditingField("password")}
              >
                Change Password
              </button>
            )}
          </div>

        </div>
      </div>
    </div >
  );
};

export default ProfilePage;